import '@ant-design/v5-patch-for-react-19';
import { Button, Space, Modal } from "antd";
import { PageHeader } from '@ant-design/pro-components';

import {
    CheckOutlined,
    ClearOutlined,
    ExclamationCircleOutlined,
} from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { hasPermissao, Papel } from './auth/entidadeUsuario';

const CadInfoBotoes = (props: any) => {
    const navigate = useNavigate();

    // Chamando objeto Confirm do Antd
    const { confirm } = Modal;


    function mostrarConfirmar() {

        confirm({
            title: props.manter === 1 ? "Deseja confirmar o cadastro?" : "Deseja confirmar as alterações?",
            width: "700px",
            icon: <ExclamationCircleOutlined />,
            content: props.msgConfirmacao,
            okButtonProps: { id: 'ok' },
            onOk() {
                props.form.validateFields();
                window.scrollTo(0, 0)
                props.form.submit();
            },
            onCancel() { },
        });

    }

    function limparCamposDesabilitar() {
        props.resetForm();

        navigate(props.rotaConsultar);
    }

    function confirmaNovaConsulta() {
        if (props.manter === 3) {
            confirm({
                title: "Nova consulta",
                width: "700px",
                icon: <ExclamationCircleOutlined />,
                content: "Deseja abandonar a edição atual? As alterações não salvas serão perdidas",
                okButtonProps: { id: 'ok' },
                onOk() {
                    novaConsulta();
                },
                onCancel() { },
            });
        } else novaConsulta();
    }

    function novaConsulta() {
        props.setManter(-1); // ESTADO INICIAL
        limparCamposDesabilitar();
        if (props.resetColor()) props.resetColor();
    }

    return (
        <>
            <PageHeader
                className='site-page-header'
                style={{ background: "#FFF" }}
                extra={
                    <div
                        style={{
                            display: "flex",
                            width: "max-content",
                            justifyContent: "flex-end",
                        }}
                    >
                        <Space align='center'>
                            <Button
                                style={{ display: props.manter >= 2 ? "inline" : "none" }}
                                shape='round'
                                onClick={() => confirmaNovaConsulta()}
                                icon={<ClearOutlined />}
                            >
                                Nova consulta
                            </Button>

                            {/* CANCELAR EDIÇÃO */}
                            <Button
                                style={{ display: props.manter === 3 ? "inline" : "none" }} // SOMENTE PARA EDIÇÃO
                                shape='round'
                                onClick={() => {
                                    props.setManter(-2); // ESTADO TEMPORÁRIO DE CANCELAMENTO DE EDIÇÃO
                                    window.scrollTo(0, 0)
                                }}
                                icon={<ClearOutlined />}
                            >
                                Cancelar
                            </Button>

                            <Button
                                style={{ display: props.manter === 2 && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : "none" }}
                                // disabled={props.desabilitaBtnEditar ? props.desabilitaBtnEditar() : true}
                                shape='round'
                                onClick={() => {
                                    props.setManter(3);
                                }}
                                type='primary'
                                icon={<ClearOutlined />}
                            >
                                Versionar
                            </Button>

                            {/* CANCELAR INCLUSÃO */}
                            <Button
                                style={{ display: (props.manter === 1) ? "inline" : "none" }} // ESTÁ NO MODO INSERIR 
                                // disabled={props.desabilitaBotoes()}
                                shape='round'
                                onClick={() => {
                                    // props.setManter(1)
                                    navigate(props.rotaConsultar);
                                }}
                                icon={<ClearOutlined />}
                            >
                                Cancelar
                            </Button>

                            <Button
                                style={{ display: (props.manter === 1 || props.manter === 3) && hasPermissao([Papel.DILIC_MASTER]) ? "inline" : "none" }} // ESTÁ NO MODO INSERIR OU ALTERAR
                                // disabled={props.desabilitaBotoes()}
                                shape='round'
                                onClick={() => {
                                    if (props.resetColor()) props.resetColor();
                                    mostrarConfirmar();
                                }}
                                type='primary'
                                icon={<CheckOutlined />}
                            >
                                Salvar
                            </Button>

                        </Space>
                    </div>
                }
            />
        </>
    );
};

export default CadInfoBotoes;
